function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInformation = function SvgInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.8 13v2",
    stroke: props.color,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3 9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z",
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.05 12a7.25 7.25 0 1 1-14.5 0 7.25 7.25 0 0 1 14.5 0Z",
    stroke: props.color,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export { SvgInformation as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjggMTNWMTUiIHN0cm9rZT0iIzExMTAxMiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEzLjMgOUMxMy4zIDkuMjc2MTQgMTMuMDc2MiA5LjUgMTIuOCA5LjVDMTIuNTIzOSA5LjUgMTIuMyA5LjI3NjE0IDEyLjMgOUMxMi4zIDguNzIzODYgMTIuNTIzOSA4LjUgMTIuOCA4LjVDMTMuMDc2MiA4LjUgMTMuMyA4LjcyMzg2IDEzLjMgOVoiIHN0cm9rZT0iIzExMTAxMiIvPgo8cGF0aCBkPSJNMjAuMDUgMTJDMjAuMDUgMTYuMDA0MSAxNi44MDQxIDE5LjI1IDEyLjggMTkuMjVDOC43OTU5OCAxOS4yNSA1LjU1MDA1IDE2LjAwNDEgNS41NTAwNSAxMkM1LjU1MDA1IDcuOTk1OTQgOC43OTU5OCA0Ljc1IDEyLjggNC43NUMxNi44MDQxIDQuNzUgMjAuMDUgNy45OTU5NCAyMC4wNSAxMloiIHN0cm9rZT0iIzExMTAxMiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";